import { LIST_ACTIVE_PROMOTIONS_QUERY } from './schema';

export async function listActivePromotions(client, options = {}) {
  const response = await client.query({
    query: LIST_ACTIVE_PROMOTIONS_QUERY,
    ...options,
  });

  return {
    data: response.data?.listActivePromotions,
    error: response.error,
  };
}
